/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiGet, apiPut } from './common/api';
import endpoints from 'src/shared/service/endpoint/endpoints.class';
import { IApiResponse } from '@shared/interface/api-response.interface';
import { IProgram } from '@shared/interface/model.interface';
import { ApiError } from '@shared/error/api.error';
import { manageApiError } from './common/api.lib';

/*****************************************
 *
 * GET FUNCTIONS
 *
 *****************************************/
/**
 * Get drops
 * @returns
 */
export const apiGetPrograms = (): Promise<any> => {
  const endpointClass = endpoints.programs.getPrograms;
  return apiGet(endpointClass.getUrl(), { publicApi: endpointClass.isPublic() })
    .then((response?: IApiResponse<Array<IProgram>, string>) => {
      if (response != null && response.returnCode === 'PRG_ALL_OK') {
        return Promise.resolve(response.returnSuccess);
      } else {
        throw new ApiError(response?.returnError ?? '', response?.returnCode);
      }
    })
    .catch((error: ErrorConstructor) =>
      manageApiError(error, 'apiGetPrograms'),
    );
};

/*****************************************
 *
 * PUT FUNCTIONS
 *
 *****************************************/
/**
 * Update the program (only the comment)
 * @returns
 */
export const apiPutProgram = (
  program: IProgram,
): Promise<IApiResponse<string, string> | undefined> => {
  const payload = {
    programComment: program.comment,
    csrf: program.csrf
  };
  return apiPut(
    endpoints.programs.putUpdateProgram.addParams([program.id ?? 0]).getUrl(),
    payload,
  )
    .then((response: IApiResponse<string, string>) => {
      if (response.returnSuccess && response.returnCode === 'PRG_UPDATE_OK') {
        return response;
      } else {
        throw new ApiError(response.returnError ?? '', response.returnCode);
      }
    })
    .catch((error: ErrorConstructor) => manageApiError(error, 'apiPutProgram'));
};
